import styled from 'styled-components';
import { APPS_PHONE_MEDIA } from './apps.constants';

export const PageRoot = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow: hidden;
  background: ${({ theme }) => theme.colors.surface};
`;

export const PageBody = styled.div`
  flex: 1 1 auto;
  min-height: 0;
  overflow-y: auto;
  padding: 14px 20px 18px;
  display: flex;
  flex-direction: column;
  gap: 12px;

  @media (max-width: 1100px) {
    padding: 16px;
  }

  ${APPS_PHONE_MEDIA} {
    padding: 12px;
  }
`;
